import axios from "axios";

//const channel_id = 'UCGCcZpghIb-RXMSJJ3Z4BvQ'
const api = 'https://www.googleapis.com/youtube/v3'
const token = 'AIzaSyCRDN3wyfYEm2VpoKkCXrrQ8PBZUSzHb3Y'
const place_id = 'ChIJD_3H-MkwBogRrzXtXkdjSTk'

export default class GoogleApiService {

    static GetToken() {
        return token;
    }

    static GetPlaceId() {
        return place_id;
    }

    static GetGoogleVideos(playlist_id) {
        return axios.get(`${api}/playlistItems?playlistId=${playlist_id}&part=id,snippet&key=${token}`)
            .then(response => {
                return response.data.items
            });
    }
}